import { supabase } from '../config/supabase';

export const adsService = {
  async getActiveAds(placement = 'footer', language = 'el') {
    const { data, error } = await supabase
      .from('hahub_ads')
      .select('*')
      .eq('placement', placement)
      .eq('is_active', true)
      .or(`language_targeting.eq.${language},language_targeting.is.null`)
      .order('priority', { ascending: false });

    if (error) {
      console.error('Error fetching ads:', error);
      return [];
    }
    return data;
  },

  async getCampaigns() {
    const { data, error } = await supabase
      .from('hahub_ad_campaigns')
      .select('*, ads:hahub_ads(*)')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    return data;
  },

  async createCampaign(campaignData) {
    const { data, error } = await supabase
      .from('hahub_ad_campaigns')
      .insert([campaignData])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async createAd(adData) {
    const { data, error } = await supabase
      .from('hahub_ads')
      .insert([adData])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async updateAd(id, adData) {
    const { data, error } = await supabase
      .from('hahub_ads')
      .update(adData)
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  }
};